import AggregatedMarketPane from './_aggregated-market-pane.js'
import PriceBoostMarketContent from './_price-boost-market-content.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'

export default {
  name: 'PriceBoostAggregatedMarket',
  values: {
    aggregatedMarketPane: {
      configSet: AggregatedMarketPane,
      configValues: {
        expandable: {
          headerContainer: {
            style: {
              base: {
                padding: '0px',
              },
            },
          },
          container: {
            style: {
              padding: '0 8px',
            },
          },
        },
      },
    },
    marketContent: {
      configSet: PriceBoostMarketContent,
      configValues: {},
    },
    showTitleIcon: true,
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          alignItems: 'center',
        },
      },
    },
    titleContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
        },
      },
    },
    titleText: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    titleIconContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: '0',
        },
      },
    },
    titleIcon: {
      configSet: Image,
      configValues: {
        src: 'promotion-priceenhancement',
        style: {
          minWidth: '14px',
          minHeight: '14px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
